import React from 'react'
import { connect } from 'react-redux'
import auth from '../../common/auth'
import { Translate, getTranslate } from 'react-localize-redux'
import acceptCertificateImg from '../../assets/images/acceptCertificate.png'
import { connectQzTray, getVersion } from '../../common/qz/qzTrayService'
import AbstractSetupPart from './AbstractSetupPart'
import qzTrayImg from '../../assets/images/qzTrayTrayIcon.png'

const SETUP_SCRIPT_WIN = '/tools/qz-tray/setup-machine.bat'
const SETUP_SCRIPT_MAC = '/tools/qz-tray/setup-machine.sh'

class VersionCheck extends AbstractSetupPart {
	constructor(props) {
		super(props)
		this.state = {
			qz: {
				qzTrayVersionCheck: { status: 'upcoming' }
			}
		}
	}

	componentDidMount() {
		this.props.registerCallback(
			this.processCheck.bind(this),
			this.resetCheck.bind(this)
		)
	}

	processCheck() {
		let newState = this.state
		newState.qz.qzTrayVersionCheck.status = 'in-progress'
		newState.qz.qzTrayVersionCheck.message = this.props.translate(
			'stationSetup.controller.CHECKING_QZ_VERSION'
		)
		this.setState(newState)
		return connectQzTray()
			.then(getVersion)
			.then(
				function(version) {
					const versionParts = version.split('.')
					const major = parseInt(versionParts[0], 10) || 0
					const minor = parseInt(versionParts[1], 10) || 0
					const sub = parseInt(versionParts[2], 10) || 0
					let newState = this.state
					if (major < 2 || (major === 2 && minor === 0 && sub < 2)) {
						newState.qz.qzTrayVersionCheck.status = 'out-of-date'
						newState.qz.qzTrayVersionCheck.message = this.props.translate(
							'stationSetup.controller.QZ_NEED_UPDATE'
						)
					} else {
						newState.qz.qzTrayVersionCheck.status = 'succeeded'
						newState.qz.qzTrayVersionCheck.message = this.props.translate(
							'stationSetup.controller.QZ_UP_TO_DATE'
						)
					}
					this.setState(newState)
				}.bind(this),
				function(err) {
					let newState = this.state
					newState.qz.qzTrayVersionCheck.status = 'failed'
					newState.qz.qzTrayVersionCheck.message = this.getErrorMessage(err)
					this.setState(newState)
					throw err
				}.bind(this)
			)
	}

	resetCheck() {
		let newState = this.state
		newState.qz.qzTrayVersionCheck = {
			status: 'upcoming',
			message: this.props.translate('stationSetup.controller.CHECK_VERSION')
		}
		this.setState(newState)
	}

	render() {
		return (
			<div
				id="qz-version"
				className={`panel ${VersionCheck.decidePanelClassname(
					this.state.qz.qzTrayVersionCheck.status
				)}`}
			>
				<div className="panel-heading">
					<span
						className={`glyphicon ${VersionCheck.decideGlyphiconClassname(
							this.state.qz.qzTrayVersionCheck.status
						)}`}
						aria-hidden="true"
					/>
					<span>{this.state.qz.qzTrayVersionCheck.message}</span>
				</div>
				{this.state.qz.qzTrayVersionCheck.status === 'out-of-date' && (
					<div className="panel-body">
						<div>
							<p className="lead">
								<Translate id="stationSetup.UPGRADE_INSTRUCTIONS_1" />
							</p>
							<h4>
								<Translate id="stationSetup.UPGRADE_INSTRUCTIONS_2" />
							</h4>
							<ol>
								<li>
									<span>
										{this.props.translate(
											'stationSetup.UPGRADE_INSTRUCTIONS_3'
										)}
									</span>
								</li>
								<li>
									<span>
										{this.props.translate(
											'stationSetup.UPGRADE_INSTRUCTIONS_4',
											{ qzTrayUrl: qzTrayImg }
										)}
									</span>
								</li>
								<li>
									{this.props.translate(
										'stationSetup.' + VersionCheck.getOs() + '_SETUP_1'
									)}
									<ul>
										<li>
											<Translate id="stationSetup.WINDOWS_SETUP_2" />
											{VersionCheck.getOs() === 'WINDOWS' && (
												<div>
													<a href={process.env.PUBLIC_URL + SETUP_SCRIPT_WIN}>setup-machine.bat</a>.
												</div>
											)}
											{VersionCheck.getOs() === 'MAC_OS' && (
												<div>
													<a href={process.env.PUBLIC_URL + SETUP_SCRIPT_MAC}>setup-machine.sh</a>.
												</div>
											)}
										</li>
										<li>
											{this.props.translate(
												'stationSetup.' + VersionCheck.getOs() + '_SETUP_3'
											)}
										</li>
									</ul>
								</li>
								<li>
									{this.props.translate(
										'stationSetup.' + VersionCheck.getOs() + '_SETUP_4',
										{ qzTrayUrl: qzTrayImg }
									)}
								</li>
								<li>
									<Translate id="stationSetup.RERUN_CHECKS_1" />
									<button
										onClick={this.props.runAllChecks.bind(this)}
										className="btn btn-primary"
									>
										<Translate id="stationSetup.RERUN_CHECKS_2" />
									</button>
								</li>
							</ol>
						</div>
						<div className="media">
							<div className="media-left media-middle">
								<img
									className="media-object"
									src={acceptCertificateImg}
									alt="QZ certificate dialog"
								/>
							</div>
							<div className="media-body">
								<h4 className="media-heading">
									<span>
										<Translate id="stationSetup.MEDIA_1" />
									</span>
								</h4>
								<span>
									<Translate id="stationSetup.MEDIA_2" />
								</span>
							</div>
						</div>
					</div>
				)}
			</div>
		)
	}
}

export default connect(state => ({
	isLoggedIn: auth.isLoggedIn(),
	translate: getTranslate(state.locale)
}))(VersionCheck)



// WEBPACK FOOTER //
// ./src/components/qzSetup/VersionCheck.js